var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Mixins, Prop, Component, Watch } from "vue-property-decorator";
import { ValidationObserver } from 'vee-validate';
import { Notification } from '@/common/services/notificationService';
import { SuomiFiResponse } from '@/common/types/SuomiFiResponse';
import TextLabelRow from '@/common/components/TextLabelRow.vue';
import TextInputRow from '@/common/components/TextInputRow.vue';
import RadioButtonRow from '@/common/components/unsavable/RadioButtonBooleanRowCustomizable.vue';
import OrganisationSearchAndSelect from '@/loginApp/template/components/registration/OrganisationSearchAndSelect.vue';
import { RegisterUserDto } from "@/common/types/RegisterUserDto";
import UserService from '@/common/services/UserService';
import OrganisationService from "@/common/services/OrganisationService";
import CheckBoxBooleanWithButton from '@/common/components/unsavable/CheckBoxBooleanWithButton.vue';
import { Focusable } from '@/common/mixins/Focusable';
var AdminUserInfo = /** @class */ (function (_super) {
    __extends(AdminUserInfo, _super);
    function AdminUserInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userService = new UserService();
        _this.organisationService = new OrganisationService();
        _this.sending = false;
        _this.selectedOrganisation = null;
        _this.userInfo = new RegisterUserDto();
        _this.confirmPassword = "";
        _this.organisations = [];
        _this.showTermsSelected = false;
        _this.termsApproved = false;
        _this.approveTermsDisabled = true;
        return _this;
    }
    AdminUserInfo.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var invite, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (localStorage.getItem("invite")) {
                            try {
                                invite = window.localStorage.getItem("invite");
                                this.userInfo = JSON.parse(invite);
                            }
                            catch (_c) {
                                Notification.error(this, this.$t("Registration.RegisterAdminUser.ParseFailed").toString());
                            }
                        }
                        this.userInfo.firstName = this.suomiFiResponse.FirstName;
                        this.userInfo.lastName = this.suomiFiResponse.LastName;
                        this.userInfo.ssn = this.suomiFiResponse.Ssn;
                        if (!!this.hasInvitation) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.organisationService.getOrganisationOptions()];
                    case 1:
                        _a.organisations = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AdminUserInfo.prototype.mounted = function () {
        this.$root.$on('registerTermsRead', this.onRegisterTermsRead);
    };
    AdminUserInfo.prototype.onRegisterTermsRead = function (isRead) {
        if (this.approveTermsDisabled)
            this.approveTermsDisabled = !isRead;
    };
    AdminUserInfo.prototype.setSelectedOrganisation = function (option) {
        if (option != null) {
            this.userInfo.organisationName = option.name;
            this.userInfo.organisationId = option.id;
        }
        else {
            this.userInfo.organisationName = null;
            this.userInfo.organisationId = null;
        }
    };
    AdminUserInfo.prototype.errorMessages = function (errors) {
        var fields = Object.getOwnPropertyNames(errors);
        if (fields.length == 1)
            return;
        var messages = [];
        if (this.hasInvitation) {
            if (errors[fields[0]].length > 0) {
                messages.push(this.$t("Registration.Password").toString() + " " + errors[fields[0]][0]);
            }
            if (errors[fields[1]].length > 0) {
                messages.push(this.$t("Registration.ConfirmPassword").toString() + " " + errors[fields[1]][0]);
            }
            if (errors[fields[2]].length > 0) {
                messages.push(this.$t("Registration.Procuration").toString() + " " + errors[fields[2]][0]);
            }
        }
        else {
            if (errors[fields[0]].length > 0) {
                messages.push(this.$t("Registration.Email").toString() + " " + errors[fields[0]][0]);
            }
            if (errors[fields[1]].length > 0) {
                messages.push(this.$t("Registration.OrganisationName").toString() + " " + errors[fields[1]][0]);
            }
            if (errors[fields[2]].length > 0) {
                messages.push(this.$t("Registration.Password").toString() + " " + errors[fields[2]][0]);
            }
            if (errors[fields[3]].length > 0) {
                messages.push(this.$t("Registration.ConfirmPassword").toString() + " " + errors[fields[3]][0]);
            }
            if (errors[fields[4]].length > 0) {
                messages.push(this.$t("Registration.Procuration").toString() + " " + errors[fields[4]][0]);
            }
        }
        return messages.join(", ");
    };
    Object.defineProperty(AdminUserInfo.prototype, "language", {
        get: function () {
            return this.$i18n.locale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdminUserInfo.prototype, "validationErrors", {
        get: function () {
            return this.observer.errors;
        },
        enumerable: false,
        configurable: true
    });
    AdminUserInfo.prototype.onLanguageChange = function () {
        var hasErrors = false;
        for (var item in this.validationErrors) {
            if (this.validationErrors[item].length > 0)
                hasErrors = true;
        }
        if (hasErrors)
            this.observer.validate();
    };
    Object.defineProperty(AdminUserInfo.prototype, "fullName", {
        get: function () {
            return this.userInfo.firstName + ' ' + this.userInfo.lastName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdminUserInfo.prototype, "hasInvitation", {
        get: function () {
            return this.userInfo.id != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdminUserInfo.prototype, "emailRules", {
        get: function () {
            return { email: true, emailnottaken: true };
        },
        enumerable: false,
        configurable: true
    });
    AdminUserInfo.prototype.isSendBtnDisabled = function (valid) {
        return this.sending || !valid || !this.termsApproved;
    };
    Object.defineProperty(AdminUserInfo.prototype, "observer", {
        get: function () {
            return this.$refs["registerAdminUserObserver"];
        },
        enumerable: false,
        configurable: true
    });
    AdminUserInfo.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isValid, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sending = true;
                        return [4 /*yield*/, this.observer.validate()];
                    case 1:
                        isValid = _a.sent();
                        if (!isValid) return [3 /*break*/, 3];
                        this.loading = true;
                        return [4 /*yield*/, this.userService.register(this.userInfo, true, this.hasInvitation)];
                    case 2:
                        response = _a.sent();
                        if (response.ok) {
                            Notification.success(this, this.$t("Registration.RegisterAdminUser.Saving.Succeeded").toString());
                            localStorage.removeItem("invite");
                            this.$emit("saved", this.userInfo);
                        }
                        else {
                            Notification.error(this, this.$t("Registration.RegisterAdminUser.Saving.Error").toString());
                        }
                        this.loading = false;
                        _a.label = 3;
                    case 3:
                        this.sending = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AdminUserInfo.prototype, "loading", {
        get: function () {
            return this.$store.state.vuexPageModule.loading;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOADING", value);
        },
        enumerable: false,
        configurable: true
    });
    AdminUserInfo.prototype.showTerms = function () {
        this.showTermsSelected = true;
        this.$root.$emit('showTerms', true); // Tell login app to show terms modal
    };
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof SuomiFiResponse !== "undefined" && SuomiFiResponse) === "function" ? _a : Object)
    ], AdminUserInfo.prototype, "suomiFiResponse", void 0);
    __decorate([
        Watch("language"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AdminUserInfo.prototype, "onLanguageChange", null);
    AdminUserInfo = __decorate([
        Component({
            name: "AdminUserInfo",
            components: {
                ValidationObserver: ValidationObserver,
                TextLabelRow: TextLabelRow,
                TextInputRow: TextInputRow,
                RadioButtonRow: RadioButtonRow,
                OrganisationSearchAndSelect: OrganisationSearchAndSelect,
                CheckBoxBooleanWithButton: CheckBoxBooleanWithButton
            }
        })
    ], AdminUserInfo);
    return AdminUserInfo;
}(Mixins(Focusable)));
export default AdminUserInfo;
